<!-- Download Indicator -->
<div *ngIf="mailService.loading">
	<div class="spinner-overlay"></div>
	<div class="spinner-content">
		<app-spinner></app-spinner>
	</div>
</div>

<div class="slate full-width full-height">
	<!-- Loading Indicator -->
	<app-spinner *ngIf="loading"></app-spinner>

	<!-- Search List Control -->
	<div *ngIf="!loading">
		<!-- Header -->
		<app-page-header [iconId]="396">Mail Batch Search</app-page-header>

		<!-- Search Control -->
		<app-search
			#mailBatchSearch
			[showCriteria]="true"
			[allowMultipleSelect]="true"
			[singleSelectCheckbox]="true"
			[autoExpand]="true"
			[displayMode]="'expandableTable'"
			[criteriaExpandedOnLoad]="true"
			[searchId]="27"
		>
		</app-search>
	</div>
</div>
